import { CarDocuments, Calendar, Manual, Safety, CertifiedRepair } from '@volkswagen-onehub/icons-core';
import { GuanteraData } from '../../guantera-data';
import React from 'react';
import { PortalContext } from '../../../../context/PortalContext';
import { Vehicle, VehicleStatus } from '@esportal/portal-service';

export const GuanteraDataListClient = () => {
	const { portalService } = React.useContext(PortalContext);

	const vehicles = portalService.getPersonVehicles().getValue();

	const filterVehiclesByMy2021 = (): Vehicle[] | undefined => {
		// December 31, 2020
		const my2021threshold = 1609372800000;

		if (vehicles?.vehicles && vehicles.vehicles.length > 0) {
			return vehicles.vehicles.filter((vehicle: Vehicle) => {
				if (!vehicle.licenseDate) return false;

				let licenseTimestamp: number;

				// Número
				if (typeof vehicle.licenseDate === 'number') {
					licenseTimestamp = vehicle.licenseDate;
				}
				// Strinf to timestamp
				else if (typeof vehicle.licenseDate === 'string') {
					const parsedDate = new Date(vehicle.licenseDate);
					if (isNaN(parsedDate.getTime())) return false;
					licenseTimestamp = parsedDate.getTime();
				} else {
					return false;
				}
				return licenseTimestamp > my2021threshold;
			});
		}

		return;
	};

	const getActualVehicles = (): Vehicle[] | undefined => {
		if (vehicles?.vehicles && vehicles.vehicles.length > 0) {
			return vehicles?.vehicles.filter(
				(vehicle: Vehicle) =>
					vehicle.status == VehicleStatus.TO_BE_CONFIRMED ||
					vehicle.status == VehicleStatus.READY ||
					vehicle.status == VehicleStatus.TO_BE_DELETED,
			);
		}
		return;
	};

	const filteredVehiclesByMy2021 = filterVehiclesByMy2021();

	const hasCarsToShow = (getActualVehicles() ?? []).length > 1;

	return (
		<>
			<GuanteraData
				text="Mi <b>mantenimiento</b>"
				icon={<CertifiedRepair variant="default" />}
				hasDivider={true}
				multipleVehicles={hasCarsToShow}
				link="maintenance-plan"
				vehicles={getActualVehicles()}
			/>
			<GuanteraData
				text="Mi <b>coche conectado</b>"
				icon={<CarDocuments variant="default" />}
				hasDivider={true}
				multipleVehicles={hasCarsToShow}
				link="myvw_dashboard"
				vehicles={getActualVehicles()}
			/>
			{filteredVehiclesByMy2021 &&
				filteredVehiclesByMy2021?.length > 0 &&
				(filteredVehiclesByMy2021?.length === 1 ? (
					<GuanteraData
						text="Mi <b>manual digital</b>"
						icon={<Manual variant="default" />}
						hasDivider={true}
						multipleVehicles={false}
						link="digital-manual"
						vehicles={filteredVehiclesByMy2021}
					/>
				) : (
					<GuanteraData
						text="Mi <b>manual digital</b>"
						icon={<Manual variant="default" />}
						hasDivider={true}
						multipleVehicles={true}
						link="digital-manual"
						vehicles={filteredVehiclesByMy2021}
					/>
				))}
			<GuanteraData
				text="¿Necesitas <b>pasar por taller?</b>"
				icon={<Calendar variant="default" />}
				hasDivider={true}
				multipleVehicles={hasCarsToShow}
				link="action:es-cca-loader--open_layer"
				vehicles={getActualVehicles()}
			/>
			<GuanteraData
				text="Mis <b>derechos en un accidente</b>"
				icon={<Safety variant="default" />}
				hasDivider={false}
				multipleVehicles={false}
				link="derechos-asegurado"
			/>
		</>
	);
};
